import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import { Button } from 'components/common/button';
import { Content } from 'components/common/modal';
import check from 'assets/imgs/success-check.svg';
import { color } from 'constants/styled-theme';

const scaleIn = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;
const Img = styled.img`
  width: 100px;
  animation: ${scaleIn} 0.5s ease-in-out;
`;
const MessageRow = styled.div`
  margin: 30px;
`;

const Message = styled.div`
  margin-top: 30px;
  font-size: 14px;
  color: ${color('fontColor')};
`;
const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 10px;
`;

export const Success = ({ closeHandler, message = 'Success' }) => (
  <Content>
    <MessageRow>
      <Img src={check} alt="check" />
      <Message>{message}</Message>
    </MessageRow>
    <ButtonRow>
      <Button gray id="ok-button" onClick={closeHandler}>
        OK
      </Button>
    </ButtonRow>
  </Content>
);

Success.propTypes = {
  closeHandler: PropTypes.func,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
